import { INextSurfacingDoConfig } from './nextSurfacing/INextSurfacingDoConfig';
import { IrisModContainer, IIrisModContainerConstParam } from './IrisModContainer';
import { IrisConfigContainer, IIrisConfigContainerConstParam } from './IrisConfigContainer';


export class IrisrawModNextSurfacingDo extends IrisModContainer<IrisConfigContainer<INextSurfacingDoConfig>> {
                
    constructor({...args }:IIrisModContainerConstParam = {} as IIrisModContainerConstParam) {
        super(args,IrisrawModNextSurfacingDo.createIrisNextSurfacingDoConfig)        
    }

    static createIrisrawModNextSurfacingDo(datas:IIrisModContainerConstParam) {        
        return new IrisrawModNextSurfacingDo(datas)
    }

    static createIrisNextSurfacingDoConfig(data:IIrisConfigContainerConstParam) {        
        return new IrisConfigContainer<INextSurfacingDoConfig>(data)
    }

}
